export default "__VITE_ASSET__yugcuGk3__"